import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { Brand, BrandLogoResponse, BrandRequest, BrandResponse, BrandSlugAvailabilityResponse, BrandUpdateRequest } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const brandApi = {
	index: (): Promise<AxiosResult<Brand[]>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces`, method: "GET" });
	},

	view: (id: string): Promise<AxiosResult<Brand>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces/${id}`, method: "GET" });
	},

	create: (payload: BrandRequest): Promise<AxiosResult<BrandResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces`, method: "POST", data: payload });
	},

	update: (id: string, request: BrandUpdateRequest): Promise<AxiosResult<BrandResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces/${id}`, method: "PATCH", data: request });
	},

	delete: (id: string): Promise<AxiosResult<BrandResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces/${id}`, method: "DELETE" });
	},

	checkSlugAvailability: (slug: string): Promise<AxiosResult<BrandSlugAvailabilityResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/workspaces/slug/check?slug=${encodeURIComponent(slug)}`, method: "GET" });
	},

	uploadLogo: (workspaceId: string, file: File): Promise<AxiosResult<BrandLogoResponse>> => {
		const formData = new FormData();
		formData.append("logo", file);

		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/logo`,
			method: "POST",
			data: formData,
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogo: (workspaceId: string): Promise<AxiosResult<BrandLogoResponse>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/logo`,
			method: "DELETE",
		});
	},
};
